var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTitlesOn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#878793;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.51,14.44a4.13,4.13,0,1,0-4.13-4.13A4.14,4.14,0,0,0,7.51,14.44Zm6-5.32h5.89a.89.89,0,0,0,0-1.77H13.48a.89.89,0,0,0,0,1.77ZM7.05,12.73a.72.72,0,0,1-.55-.21L5.08,11a.7.7,0,0,1-.2-.47.67.67,0,0,1,.7-.69.69.69,0,0,1,.5.2l.91,1L8.87,8.48a.7.7,0,0,1,.57-.3.68.68,0,0,1,.68.69.65.65,0,0,1-.12.38L7.61,12.48A.71.71,0,0,1,7.05,12.73Zm6.43.48h5.89a.88.88,0,1,0,0-1.76H13.48a.88.88,0,1,0,0,1.76Zm-9.21,4.6h15.1a.89.89,0,0,0,0-1.77H4.27a.89.89,0,1,0,0,1.77Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTitlesOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-titles-on.4e7d31f55282aa27b76321c053d631c7.svg";